"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = ["disabled"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_6 = { class: "flex items-center gap-2" };
const _hoisted_7 = ["checked"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "ID", -1);
const _hoisted_9 = { class: "flex items-center gap-2" };
const _hoisted_10 = ["value"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_18 = { class: "flex items-center my-5 gap-4" };
const _hoisted_19 = ["href"];
const _hoisted_20 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const Newsletter_1 = require("../../stores/newsletters/Newsletter");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const NewsletterRequest_1 = require("../../stores/newsletters/NewsletterRequest");
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const newsletterStore_1 = require("../../stores/newsletters/newsletterStore");
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminNewsletters',
    setup(__props) {
        var _a, _b, _c;
        const newsletterStore = (0, newsletterStore_1.useNewsletterStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const newslettersLoading = (0, vue_3.computed)(() => newsletterStore.loading);
        const newsletters = (0, vue_3.computed)(() => newsletterStore.newsletters);
        const totalNewsletters = (0, vue_3.computed)(() => newsletterStore.totalNewsletters);
        const errorMessage = (0, vue_3.ref)("");
        const modalIsOpen = (0, vue_3.ref)(false);
        const selectedNewsletter = (0, vue_3.ref)(null);
        const selectedNewsletterName = (0, vue_3.ref)(null);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "newsletters")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "thumbnailUrl",
                label: (_b = (0, i18n_1.trans)("thumbnail", "Thumbnail", "newsletters")) !== null && _b !== void 0 ? _b : "Thumbnail",
                value: "thumbnailUrl",
                filterable: false,
                sortable: false,
            },
            {
                key: "title",
                label: (_c = (0, i18n_1.trans)("title", "Title", "newsletters")) !== null && _c !== void 0 ? _c : "Title",
                value: "title",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const newsletterRequest = (0, vue_3.ref)(new NewsletterRequest_1.NewsletterRequest());
        const dynamicVariables = {};
        const selectedNewsletterIds = (0, vue_3.ref)([]);
        (0, vue_3.onBeforeMount)(() => {
            newsletterStore.reset();
            Newsletter_1.NEWSLETTER_CATEGORIES.forEach(function (value) {
                dynamicVariables[`${value}`] = (0, vue_3.ref)(false);
            });
        });
        const addNewsletter = () => {
            newsletterRequest.value = new NewsletterRequest_1.NewsletterRequest();
            selectedNewsletterName.value = null;
            selectedNewsletter.value = null;
            modalIsOpen.value = true;
        };
        const editNewsletter = (newsletter) => {
            var _a, _b, _c, _d;
            selectedNewsletterName.value = newsletter.title;
            selectedNewsletter.value = { ...newsletter };
            (_a = selectedNewsletter.value) === null || _a === void 0 ? void 0 : _a.category.forEach(function (value) {
                dynamicVariables[`${value}`].value = true;
            });
            newsletterRequest.value = new NewsletterRequest_1.NewsletterRequest((_b = selectedNewsletter.value) === null || _b === void 0 ? void 0 : _b.title, (_c = selectedNewsletter.value) === null || _c === void 0 ? void 0 : _c.category, (_d = selectedNewsletter.value) === null || _d === void 0 ? void 0 : _d.originalFilename, null);
            modalIsOpen.value = true;
        };
        const deleteNewsletter = async (newsletter) => {
            if (!confirm((0, i18n_1.trans)("delete_newsletter_confirm", "Are you sure?", "newsletters"))) {
                return;
            }
            errorMessage.value = "";
            selectedNewsletterName.value = newsletter.title;
            selectedNewsletter.value = { ...newsletter };
            try {
                await newsletterStore.deleteNewsletter(router, selectedNewsletter.value);
                // Erre a DEV-4005 feladat miatt van szükség
                // Ha kiválaszottunk már néhány hírlevelet, de az egyiket külön töröljük, akkor
                // vegyük ki a kiválasztottak közül
                if (selectedNewsletter.value && selectedNewsletterIds.value.includes(selectedNewsletter.value.id)) {
                    selectedNewsletterIds.value = selectedNewsletterIds.value.filter(id => { var _a; return id !== ((_a = selectedNewsletter.value) === null || _a === void 0 ? void 0 : _a.id); });
                }
                newsletterStore.reset();
                page.value = 1;
                try {
                    await newsletterStore.getNewsletters(router, {});
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const createNewsletter = async () => {
            var _a;
            errorMessage.value = "";
            Object.keys(dynamicVariables).forEach((key) => {
                if (dynamicVariables[key].value) {
                    newsletterRequest.value.category.push(key);
                }
            });
            if (Object.values(dynamicVariables).every(refValue => !refValue.value)) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("category_invalid", "You need to choose a newsletter category!", "newsletters")) !== null && _a !== void 0 ? _a : "You need to choose a newsletter category!");
                return;
            }
            try {
                await newsletterStore.createNewsletter(router, newsletterRequest.value);
                modalIsOpen.value = false;
                newsletterStore.reset();
                page.value = 1;
                try {
                    await newsletterStore.getNewsletters(router, {});
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const updateNewsletter = async () => {
            var _a, _b;
            errorMessage.value = "";
            if (Object.values(dynamicVariables).every(refValue => !refValue.value)) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("category_invalid", "You need to choose a newsletter category!", "newsletters")) !== null && _a !== void 0 ? _a : "You need to choose a newsletter category!");
                return false;
            }
            Newsletter_1.NEWSLETTER_CATEGORIES.forEach(function (value) {
                let checked = newsletterRequest.value.category.indexOf(value);
                if (dynamicVariables[value].value && checked < 0) {
                    newsletterRequest.value.category.push(value);
                }
                else if (!dynamicVariables[value].value && checked >= 0) {
                    newsletterRequest.value.category.splice(checked, 1);
                }
            });
            try {
                await newsletterStore.updateNewsletter(router, { newsletterRequest: newsletterRequest.value, id: (_b = selectedNewsletter.value) === null || _b === void 0 ? void 0 : _b.id });
                modalIsOpen.value = false;
                newsletterStore.reset();
                page.value = 1;
                try {
                    await newsletterStore.getNewsletters(router, {});
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const bulkDeleteNewsletters = async () => {
            if (!confirm((0, i18n_1.trans)("delete_selected_confirm", "Are you sure to delete selected newsletters?", "newsletters")))
                return;
            try {
                await newsletterStore.newsletterBulkDelete(router, selectedNewsletterIds.value);
                await newsletterStore.getNewsletters(router, {});
                selectedNewsletterIds.value = [];
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const allSelected = (0, vue_3.computed)(() => {
            return newsletters.value.length > 0 &&
                newsletters.value.every(n => selectedNewsletterIds.value.includes(n.id));
        });
        const toggleAll = (event) => {
            const checked = event.target.checked;
            if (checked) {
                selectedNewsletterIds.value = newsletters.value.map(n => n.id);
            }
            else {
                selectedNewsletterIds.value = [];
            }
        };
        //WATCHERS
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
                Object.keys(dynamicVariables).forEach((key) => {
                    dynamicVariables[key].value = false;
                });
            }
        });
        (0, vue_3.watch)([listFields.value, page, itemsPerPage, sortBy, sortDesc], async () => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            try {
                await newsletterStore.getNewsletters(router, {
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    order: {
                        [sortBy.value]: sortDesc.value ? "desc" : "asc",
                    },
                    ...filters,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (addNewsletter()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_newsletter", "Add Newsletter", "newsletters")), 1)
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-danger ml-2",
                        onClick: bulkDeleteNewsletters,
                        disabled: selectedNewsletterIds.value.length === 0
                    }, [
                        _hoisted_5,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete_selected", "Delete Selected", "newsletters")), 1)
                    ], 8, _hoisted_4)
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[3] || (_cache[3] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(newsletters),
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: (0, vue_2.unref)(newslettersLoading),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[4] || (_cache[4] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[5] || (_cache[5] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[7] || (_cache[7] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: (0, vue_2.unref)(totalNewsletters)
                }, {
                    "head-id": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("input", {
                                type: "checkbox",
                                checked: (0, vue_2.unref)(allSelected),
                                onChange: toggleAll,
                                onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["stop"])),
                                class: "form-checkbox h-5 w-5 text-primary"
                            }, null, 40, _hoisted_7),
                            _hoisted_8
                        ])
                    ]),
                    "cell-id": (0, vue_2.withCtx)(({ item: newsletter }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedNewsletterIds).value = $event)),
                                value: newsletter.id,
                                class: "form-checkbox h-5 w-5 text-primary"
                            }, null, 8, _hoisted_10), [
                                [vue_2.vModelCheckbox, selectedNewsletterIds.value]
                            ]),
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(newsletter.id), 1)
                        ])
                    ]),
                    "cell-thumbnailUrl": (0, vue_2.withCtx)(({ item: newsletter }) => [
                        (0, vue_2.createElementVNode)("img", {
                            src: newsletter.thumbnailUrl,
                            class: "w-[100px] bg-white"
                        }, null, 8, _hoisted_11)
                    ]),
                    "cell-title": (0, vue_2.withCtx)(({ item: newsletter }) => [
                        (0, vue_2.createElementVNode)("a", {
                            href: newsletter.fileUrl,
                            class: "underline",
                            target: "_blank"
                        }, (0, vue_2.toDisplayString)(newsletter.title), 9, _hoisted_12)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: newsletter }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (editNewsletter(newsletter))
                            }, [
                                _hoisted_15,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "newsletters")), 1)
                            ], 8, _hoisted_14),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteNewsletter(newsletter))
                            }, [
                                _hoisted_17,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "newsletters")), 1)
                            ], 8, _hoisted_16)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: selectedNewsletterName.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_newsletter_modal_title', 'Edit Newsletter: {group}', 'newsletters', { group: selectedNewsletterName.value })
                        : (0, vue_2.unref)(i18n_1.trans)('add_newsletter_modal', 'Add Newsletter', 'newsletters'),
                    onClose: _cache[12] || (_cache[12] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'newsletters'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('newsletter_title_placeholder', 'Newsletter Title', 'newsletters'),
                            label: (0, vue_2.unref)(i18n_1.trans)('newsletter_title_label', 'Newsletter Title', 'newsletters'),
                            required: "",
                            modelValue: newsletterRequest.value.title,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((newsletterRequest.value.title) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(dynamicVariables, (item, index) => {
                                return (0, vue_2.createElementVNode)("div", { key: index }, [
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        label: (0, vue_2.unref)(i18n_1.trans)('is_' + index + '_newsetter', index + ' newsletter: ', 'newsletters'),
                                        modelValue: dynamicVariables[index].value,
                                        "onUpdate:modelValue": ($event) => ((dynamicVariables[index].value) = $event),
                                        class: "p-2 bg-gray justify-between w-full"
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                                ]);
                            }), 64))
                        ]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInputBase64), {
                            "base64-encode-file": newsletterRequest.value.base64EncodedFile,
                            "onUpdate:base64EncodeFile": _cache[9] || (_cache[9] = ($event) => ((newsletterRequest.value.base64EncodedFile) = $event)),
                            "original-filename": newsletterRequest.value.originalFilename,
                            "onUpdate:originalFilename": _cache[10] || (_cache[10] = ($event) => ((newsletterRequest.value.originalFilename) = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('newsletter_file', 'Newsletter File (PDF)', 'newsletters'),
                            accept: "application/pdf",
                            placeholder: "Image",
                            class: "my-5"
                        }, null, 8, ["base64-encode-file", "original-filename", "label"]),
                        (selectedNewsletter.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                key: 1,
                                href: selectedNewsletter.value.fileUrl,
                                class: "underline",
                                target: "_blank"
                            }, (0, vue_2.toDisplayString)(selectedNewsletter.value.filename), 9, _hoisted_19))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-success",
                                onClick: _cache[11] || (_cache[11] = ($event) => (selectedNewsletter.value === null
                                    ? createNewsletter()
                                    : updateNewsletter()))
                            }, [
                                _hoisted_21,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "newsletters")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
